import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { TemplateEditorUtilsService } from '../../services/template-editor-utils.service';
import { StorageUtilsService } from 'src/app/storage/services/storage-utils.service';

@Injectable({
  providedIn: 'root',
})
export class FileMetadataUtilsService {
  static readonly DEFAULT_VIDEO_THUMBNAIL = 'streamline:video';

  constructor(
    private templateEditorUtils: TemplateEditorUtilsService,
    private storageUtilsService: StorageUtilsService,
  ) {}

  _addFileToSet(selectedImages, defaultThumbnailUrl, file, alwaysAppend) {
    var filePath = this.storageUtilsService.getFilePath(file);
    var initialLength = selectedImages.length;
    var timeCreated = this.storageUtilsService.timeCreatedFor(file);
    var thumbnail = this.thumbnailFor(file, defaultThumbnailUrl);

    var newFile: any = {
      file: filePath,
      exists: true,
      'time-created': timeCreated,
      'thumbnail-url': thumbnail,
    };
    const mediaLink = file.mediaLink || file['media-link'];

    if (mediaLink) {
      newFile['media-link'] = mediaLink;
    }

    this.templateEditorUtils.addOrReplaceAll(
      selectedImages,
      {
        file: filePath,
      },
      newFile,
    );

    if (alwaysAppend && initialLength === selectedImages.length) {
      selectedImages.push(newFile);
    }
  }

  thumbnailFor(item, defaultThumbnailUrl?) {
    if (item.metadata && item.metadata.thumbnail) {
      return (
        item.metadata.thumbnail +
        this.storageUtilsService.getTimeCreatedQuery(item)
      );
    } else {
      return defaultThumbnailUrl;
    }
  }

  videoPosterUrlFor(mediaLink?: string): string {
    if (!mediaLink) {
      return '';
    }

    return mediaLink + (mediaLink.indexOf('?') > -1 ? '&t=3' : '?t=3');
  }

  metadataForSave(metadata) {
    return _.map(metadata, (entry) => {
      const item = _.cloneDeep(entry);

      delete item['media-link'];
      delete item.previewFailed;

      return item;
    });
  }

  extractFileNamesFrom(metadata) {
    return _.map(metadata, (entry) => {
      return entry.file;
    });
  }

  filesAttributeFor(metadata) {
    return this.extractFileNamesFrom(metadata).join('|');
  }

  filesAttributeToArray(files?) {
    var fileNames;

    if (files) {
      fileNames = Array.isArray(files) ? _.cloneDeep(files) : files.split('|');
    } else {
      fileNames = [];
    }

    return fileNames;
  }

  metadataWithFile(
    previousMetadata,
    defaultThumbnailUrl,
    files,
    alwaysAppend?,
  ) {
    var metadata = _.cloneDeep(previousMetadata);

    files.forEach((file) => {
      this._addFileToSet(metadata, defaultThumbnailUrl, file, alwaysAppend);
    });

    return metadata;
  }

  metadataWithFileRemoved(previousMetadata, entry) {
    var idx = previousMetadata.indexOf(entry);
    var metadata = _.cloneDeep(previousMetadata);

    if (idx >= 0) {
      metadata.splice(idx, 1);

      return metadata;
    }
  }

  getUpdatedFileMetadata(currentMetadata, newMetadata) {
    if (!currentMetadata) {
      return newMetadata;
    } else {
      var atLeastOneOriginalEntryIsStillSelected = false;
      var metadataCopy = _.cloneDeep(currentMetadata);

      _.each(newMetadata, (entry) => {
        var currentEntry = _.find(metadataCopy, {
          file: entry.file,
        });

        if (currentEntry) {
          atLeastOneOriginalEntryIsStillSelected = true;
          currentEntry.exists = entry.exists;
          currentEntry['thumbnail-url'] = entry['thumbnail-url'];
          currentEntry['time-created'] = entry['time-created'];
          if (entry['media-link']) {
            currentEntry['media-link'] = entry['media-link'];
          }
        }
      });

      return atLeastOneOriginalEntryIsStillSelected ? metadataCopy : null;
    }
  }
}
